import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useScreenContentTypes } from 'hooks/useScreens'
import { getFeaturedContent } from 'services/content-service'
import { getRelatedContentArray } from 'utils/relatedContent'
import { FEATURED_VIDEOS, GENERAL_CONTENTS, QUOTES, GENERAL_EVENTS } from 'constants/appConstants'
import View from './view'

const Dashboard = ({ zone, searchMode, search, searchQuery, handleStatus }) => {
  const [events, setEvents] = useState([])
  const [featuredItems, setFeaturedItems] = useState([])
  const [isEventsLoading, setIsEventsLoading] = useState(true)
  const [isFeaturedLoading, setIsFeaturedLoading] = useState(true)

  const { state } = useLocation()
  const screenApp = localStorage.getItem('screenApp')
  const contentTypes = useScreenContentTypes(state ? state.screenSelected : JSON.parse(screenApp).value)
  const contentTypesArray = Object.keys(contentTypes)

  //Tipo de contenido UpcomingEvents ya no existe
  useEffect(() => {
    setIsEventsLoading(true)
    // getUpcomingEvents(zone)
    //   .then(response => setEvents(response.data.data))
    //   .catch(err => console.log(err))
    //   .finally(() => setIsEventsLoading(false))
    setEvents([])
    setIsEventsLoading(false)
  }, [])

  useEffect(() => {
    setIsFeaturedLoading(true)
    getFeaturedContent(JSON.parse(screenApp).value)
      .then(response => {
        // const bios = response.data.data[0].bios.data
        // bios.forEach(bio => {
        //   bio.contentType = BIOS
        // })
        // const athleticTeams = response.data.data[0].athleticTeams.data
        // athleticTeams.forEach(athleticTeam => {
        //   athleticTeam.contentType = ATHLETIC_TEAMS
        // })
        const quotes = response.data.data[0].quotes
        quotes?.forEach(quote => {
          quote.contentType = QUOTES
        })
        const featuredVideos = response.data.data[0].featured_videos
        featuredVideos?.forEach(featuredVideo => {
          featuredVideo.contentType = FEATURED_VIDEOS
        })
        const generalContents = response.data.data[0].general_contents
        generalContents?.forEach(generalContent => {
          generalContent.contentType = GENERAL_CONTENTS
        })
        const generalEvents = response.data.data[0].general_events
        generalEvents?.forEach(generalEvent => {
          generalEvent.contentType = GENERAL_EVENTS
        })
        // const posters = response.data.data[0].posters.data
        // posters.forEach(poster => {
        //   poster.contentType = POSTERS
        // })
        // const customContents = response.data.data[0].customContents.data
        // customContents.forEach(customContent => {
        //   customContent.contentType = CUSTOM_CONTENTS
        // })
        setFeaturedItems(
          getRelatedContentArray(
            null,
            // [...bios, ...athleticTeams, ...quotes, ...featuredVideos, ...posters, ...customContents],
            [...featuredVideos, ...generalEvents, ...generalContents, ...quotes],
            3
          )
        )
      })
      .catch(err => console.log(err))
      .finally(() => setIsFeaturedLoading(false))
  }, [])

  return (
    <View
      zone={zone}
      events={events}
      featuredItems={featuredItems}
      searchMode={searchMode}
      search={search}
      searchQuery={searchQuery}
      handleStatus={handleStatus}
      contentTypesArray={contentTypesArray}
      isEventsLoading={isEventsLoading}
      isFeaturedLoading={isFeaturedLoading}
    />
  )
}

Dashboard.defaultProps = {
  search: [] || {},
  searchMode: false,
  handleStatus: () => {},
  searchQuery: '',
}

Dashboard.propTypes = {
  zone: PropTypes.string.isRequired,
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  searchMode: PropTypes.bool,
  handleStatus: PropTypes.func,
  searchQuery: PropTypes.string,
}

export default Dashboard
